// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2n_fl","noInteraction":"EventWrapper_noInteraction__Wkl79","pointerPassthrough":"EventWrapper_pointerPassthrough__3Qq2q"};